export default {
  init() {
    // JavaScript to be fired on the example page page
  },
  finalize() {
    // JavaScript to be fired on the example page page, after the init JS

    /* eslint-disable */
    
    var sliderOne = $('#slider-one').lightSlider({
        item: 1,
        autoWidth: false,
        slideMove: 1, // slidemove will be 1 if loop is true
        // slideMargin: 0,
  
        // addClass: '',
        mode: 'slide',
        // mode: 'fade',
        useCSS: true,
        // cssEasing: 'ease', //'cubic-bezier(0.25, 0, 0.25, 1)',//
        // easing: 'linear', //'for jquery animation',////
  
        speed: 1200, //ms'
        auto: false,
        loop: false,
        slideEndAnimation: false,
        // pause: 2000,
  
        keyPress: false,
        controls: false,
        prevHtml: '',
        nextHtml: '',
  
        rtl: false,
        adaptiveHeight: false,
  
        // vertical: false,
        // verticalHeight: 0,
        // vThumbWidth: 0,
  
        // thumbItem: 0,
        pager: false,
        gallery: false,
        // galleryMargin: 0,
        thumbMargin: 30,
        currentPagerPosition: 'left',
  
        enableTouch: true,
        enableDrag: true,
        freeMove: true,
        swipeThreshold: 1,
  
        responsive : [],
  
        onBeforeStart: function (el) { },
        onSliderLoad: function (el) {},
        onBeforeSlide: function (el) {
        	// $('#slider-one .lslide.active').addClass('out');
        	// setTimeout(function(){
        	// 	$('#slider-one .lslide').removeClass('out');
        	// }, 1200);
        },
        onAfterSlide: function (el) {
        	// $('#slider-one .lslide.active').addClass('in');
        	// setTimeout(function(){
        	// 	$('#slider-one .lslide').removeClass('in');
        	// }, 1200);
        },
        onBeforeNextSlide: function (el) {},
        onBeforePrevSlide: function (el) {}
    });

    // Custom Paging for light slider
    $('#slider-one-outer .bws-pager .bws-item').click(function(e) {
    	e.preventDefault();

    	let pagerItems = $('#slider-one-outer .bws-pager .bws-item');

    	let itemNumber = this.getAttribute('data-thumb') - 1; // minus one other wise lightslider dosen't get the correct slide
    	// console.log(itemNumber);
    	$(pagerItems).removeClass('active');
    	this.classList.add('active');

    	sliderOne.goToSlide(itemNumber);
    });
   
    /* eslint-enable */

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/examplePage.js